export default {
  namespaced: true,
  state: () => ({
    object: null
  }),
  mutations: {
    set(state, payload) {
      state.object = payload;
    },
    clear(state) {
      state.object = null;
    }
  },
  actions: {
    saveApplicant({ commit }, object) {
      commit('set', object);
    },
    resetApplicant({ commit }) {
      commit('clear');
    }
  },
  getters: {
    getApplicant: (state) => state.object
  }
};